// extracted by mini-css-extract-plugin
export var card = "Card-module--card--1HEAs";
export var image = "Card-module--image--nOoYd";
export var title = "Card-module--title--21AQ-";
export var big = "Card-module--big--um4w2";
export var inner = "Card-module--inner--G46uZ";
export var body = "Card-module--body--3GGhj";
export var grid = "Card-module--grid--GnxV9";
export var list = "Card-module--list--18BLl";